const { showError, showNotifikasi } = require('../libs/helper');
var qs = require('qs');

module.exports = {
    getListPerkin: async (g, params) => {
        const result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/get-list-perkin',
            params
        })
            .then(res => {
                try {
                    if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
                        showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)
                } catch (error) {
                    console.log(error);
                }

                return res.data
            })
            .catch(err => {
                showError(g, err, `Error Get Data`)
            })
        return result;
    },
    getGabunganPerkin: async (g, params) => {
        const result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/get-skpd-perkin',
            params
        })
            .then(res => {
                try {
                    if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
                        showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)
                } catch (error) {
                    console.log(error);
                }

                return res.data
            })
            .catch(err => {
                showError(g, err, `Error Get Data`)
            })
        return result;
    },
    submit: async (g, data) => {
        await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/store-perkin',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
            .then(res => {
                try {
                    if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
                        showNotifikasi(g, 'danger', 'Error Submit Form', res.data.message)
                    else
                        g.$router.push({ name: 'perkin' })
                } catch (error) {
                    g.$router.push({ name: 'perkin' })
                }
            })
            .catch(err => {
                showError(g, err, `Error Submit Form`)
            })
    },
    getAllPerkin: async (g, params) => {
        const result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/get-all-list-perkin',
            params
        })
            .then(res => {
                try {
                    if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
                        showNotifikasi(g, 'danger', 'Error Get Data', res.data.message)
                } catch (error) {
                    console.log(error);
                }

                return res.data
            })
            .catch(err => {
                showError(g, err, `Error Get Data`)
            })
        return result;
    },
};